"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.29,12.16a1.63,1.63,0,0,1-.35-.53A1.63,1.63,0,0,0,8.29,12.16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.94,10.43a1.63,1.63,0,0,1,.35-.53A1.63,1.63,0,0,0,7.94,10.43Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,4.5A3.5,3.5,0,1,0,19.51,8,3.5,3.5,0,0,0,16,4.5Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.91,16.66a1.81,1.81,0,0,1-.35.53A1.81,1.81,0,0,0,15.91,16.66Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.41,9.43a1.54,1.54,0,0,0-.87.27,1.54,1.54,0,0,1,.87-.27Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.56,14.93a1.81,1.81,0,0,1,.35.53A1.81,1.81,0,0,0,15.56,14.93Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.86,10.23l4.7,4.7-4.7-4.7-.32-.33a1.16,1.16,0,0,0-.25-.2,1.16,1.16,0,0,1,.25.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,16.36a1.52,1.52,0,0,0,0-.6A1.52,1.52,0,0,1,16,16.36Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,0A8,8,0,0,0,8,8a5.77,5.77,0,0,0,.07.79,2.7,2.7,0,0,1,1.3-.36,2.58,2.58,0,0,1,1.84.76l.32.33,4.69,4.71a2.59,2.59,0,0,1,0,3.66L13.6,20.57c1.07,1.78,1.91,3.05,2,3.21A.5.5,0,0,0,16,24a.52.52,0,0,0,.42-.22C16.75,23.31,24,12.24,24,8A8,8,0,0,0,16,0Zm0,11.5A3.5,3.5,0,1,1,19.51,8,3.5,3.5,0,0,1,16,11.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.91,16.66a2.63,2.63,0,0,0,.08-.3,1.52,1.52,0,0,0,0-.6c0-.1-.05-.2-.08-.3a1.81,1.81,0,0,0-.35-.53l-4.7-4.7-.32-.33a1.16,1.16,0,0,0-.25-.2,1.57,1.57,0,0,0-.88-.27,1.54,1.54,0,0,0-.87.27,1.39,1.39,0,0,0-.19.15l-.06.05a1.63,1.63,0,0,0-.35.53,1.56,1.56,0,0,0,0,1.2,1.63,1.63,0,0,0,.35.53l1.59,1.59.71.72h-9a1.59,1.59,0,1,0,0,3.18h9L8.29,20a1.63,1.63,0,0,0-.35.53,1.56,1.56,0,0,0,0,1.2,1.63,1.63,0,0,0,.35.53,1.16,1.16,0,0,0,.25.2,1.54,1.54,0,0,0,.87.27h0a1.55,1.55,0,0,0,.56-.11,1.47,1.47,0,0,0,.49-.3l.08-.06,2.53-2.54,2.49-2.49A1.81,1.81,0,0,0,15.91,16.66Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.41,9.43h0a1.57,1.57,0,0,1,.88.27A1.57,1.57,0,0,0,9.41,9.43Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;